/**
 * Riders Corner Page
 *
 * Main page for displaying riders corner trips with search functionality
 *
 * Follows Container-Presenter Pattern:
 * - Page component handles SEO and page-level concerns
 * - Container component handles business logic
 * - Presenter component handles UI rendering
 */

import React from 'react';
import SeoHead, {
  DEFAULT_META_DESCRIPTION,
  DEFAULT_META_TITLE,
} from '../../components/common/SeoHead';
import { RidersCornerContainer } from '@/components/riders-corner/RidersCornerContainer';

export default function RidersCornerPage() {
  return (
    <>
      <SeoHead
        title={DEFAULT_META_TITLE}
        description={DEFAULT_META_DESCRIPTION}
        path='/riders-corner'
        image='https://nexgo.travel/assets/images/og-riders.png'
        disableTitleSuffix
      />
      <RidersCornerContainer />
    </>
  );
}
